import React from 'react'
import {dialogStyleSheet} from '../../style/FallbackStyles';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import DefaultIconButton from '../buttons/DefaultIconButton';

const DefaultDialogTitle = ({
        classes={},
        onHandleClose,
        dialogTitle,
        dialogContext,
        underlineTitle,
    }) => {
    return (
        <DialogTitle
            classes={{root: underlineTitle && classes.slimLineDialog}}
            className={underlineTitle ? classes.underlineTitle : null}
        >
            {dialogTitle}
            {onHandleClose ? (
                <DefaultIconButton
                    color="inherit"
                    onClick={onHandleClose}
                    ariaLabel="Close"
                    className={classes.closeButton}
                    {...dialogContext}
                >
                    <CloseIcon/>
                </DefaultIconButton>
            ) : null}
        </DialogTitle>
    )
}

export default (DefaultDialogTitle)